import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from '@components/base';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';
import { getSortableFieldDefs } from '@modules/layouts/hooks/useSearchAndFilter/utils';

type OrderByFieldSelectProps = {
  id?: string;
  onSelect: (value: string) => void;
  value?: string;
};

const OrderByFieldSelect: FC<OrderByFieldSelectProps> = ({ onSelect, value }) => {
  const { t } = useTranslation();

  const {
    filterDefLoad: { data },
  } = useSearchAndFilter();

  const {
    searchQuery: { orderBy },
  } = useSearchAndFilter();

  const sortableFieldDefs = getSortableFieldDefs(data);

  const takenValues = orderBy.map(({ field }) => field);

  return (
    <Select
      label={t('field')}
      onChange={({ target: { value: newValue } }) => onSelect(newValue)}
      options={sortableFieldDefs.map(option => ({
        disabled: option.propertyName !== value && takenValues.includes(option.propertyName),
        label: option.displayName,
        value: option.propertyName,
      }))}
      value={value}
    />
  );
};

export default OrderByFieldSelect;
